import { Card, CardContent } from "@/components/ui/card";
import { Target, MapPin, Settings, CheckCircle, Phone, ArrowRight } from "lucide-react";
import renestSymbol from "@/assets/renest-symbol.png";
const HowItWorksSection = () => {
  const steps = [{
    icon: Target,
    title: "Les employés gagnent des points",
    description: "Chaque mois, vos employés accumulent des Nest Points selon leur ancienneté et performance."
  }, {
    icon: MapPin,
    title: "Ils choisissent leur destination",
    description: "Parcours de destinations soigneusement sélectionnées et adaptées au télétravail."
  }, {
    icon: Settings,
    title: "Renest s'occupe de la logistique",
    description: "Visa, logement, coworking, accueil local... Nous gérons tout de A à Z."
  }, {
    icon: CheckCircle,
    title: "L'entreprise valide en 1 clic",
    description: "Dashboard de pilotage simple pour approuver les demandes et suivre les budgets."
  }, {
    icon: Phone,
    title: "Le salarié reçoit une confirmation",
    description: "Les équipes Renest prennent contact avec lui et lancent les démarches."
  }, {
    icon: ArrowRight,
    title: "Les points sont débités, tout démarre",
    description: "La destination est validée, la communauté locale est activée, tout est prêt !"
  }];
  return <section className="py-24 px-4 bg-background">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Comment ça marche ?
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">Un processus fluide et automatisé qui transforme le temps de vos équipes en expériences extraordinaires.</p>
        </div>

        {/* Symbole Renest */}
        <div className="flex justify-center mb-16">
          <img 
            src={renestSymbol} 
            alt="Renest Symbol" 
            className="w-32 h-auto animate-fade-in"
            width="256"
            height="256"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {steps.map((step, index) => <div key={index} className="relative">
              <Card className="text-center hover:shadow-card transition-shadow duration-300 h-full">
                <CardContent className="pt-8 pb-6">
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-bold">
                      {index + 1}
                    </div>
                  </div>
                  <div className="mx-auto w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 mt-4">
                    <step.icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="font-semibold text-lg mb-3 text-foreground">{step.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
                </CardContent>
              </Card>
              {index < steps.length - 1 && index % 3 !== 2 && <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                  <div className="w-6 h-0.5 bg-primary/30"></div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
};
export default HowItWorksSection;